module.exports = __webpack_public_path__ + "static/img/application2-6.d18e344.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application2-6.jpg
// module id = QICt
// module chunks = 0